module.exports = __webpack_public_path__ + "img/ccdszuzhitop.00ff32fd.png";